module.exports = __webpack_public_path__ + "components/closing-infographics/static/infographic__mobile--CH-03a1203abac79fae46e309ede9bf0ed2.jpg";